import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { Checkbox, Label } from '@zocdoc-frontend-common/components-checkbox';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { white } from '@zocdoc/branding/colors';

const CheckBoxGroup = ({ options = [], onChange = () => {} }) => {
    const [selected, setSelected] = useState(() => {
        let selectedState = {};
        options.forEach(({ _, value }) => {
            selectedState = { ...selectedState, [value]: false };
        });
        return selectedState;
    });

    const handleCheckCheckbox = useCallback(
        (checked, e) => {
            const value = e.target.dataset.value;
            const newSelected = { ...selected, [value]: checked };
            setSelected(newSelected);
            onChange(newSelected);
        },
        [onChange, selected]
    );

    const _options = options.map((o, i) => {
        const { label, value } = o;
        return (
            <Option key={i}>
                <Checkbox dataValue={value} onChecked={handleCheckCheckbox}>
                    {label}
                </Checkbox>
            </Option>
        );
    });
    return <Wrapper>{_options}</Wrapper>;
};

export const CheckBoxGroupWithNoneOfTheseApply = ({
    options = [],
    onChange = () => {},
    noneOfTheseApplyFieldOption = 'none_of_these_apply',
}) => {
    const [selected, setSelected] = useState(init(options));
    const [instance, setInstance] = useState({
        noneOfTheseApply: 0,
        rest: 0,
    });

    const handleCheckCheckbox = useCallback(
        (checked, e) => {
            const value = e.target.dataset.value;
            if (value === noneOfTheseApplyFieldOption) {
                const newSelected = {
                    ...init(options),
                    [noneOfTheseApplyFieldOption]: true,
                };
                setInstance({ ...instance, rest: instance.rest + 1 });
                setSelected(newSelected);
                onChange(newSelected);
                return;
            }

            setInstance({
                ...instance,
                noneOfTheseApply: instance.noneOfTheseApply + 1,
            });
            const newSelected = {
                ...selected,
                [value]: checked,
                [noneOfTheseApplyFieldOption]: false,
            };
            setSelected(newSelected);
            onChange(newSelected);
        },
        [instance, noneOfTheseApplyFieldOption, onChange, options, selected]
    );

    const _options = options.map((o, i) => {
        const { label, value } = o;
        const key =
            value === noneOfTheseApplyFieldOption
                ? `${i}-${instance.noneOfTheseApply}`
                : `${i}-${instance.rest}`;
        return (
            <Option key={key}>
                <Checkbox dataValue={value} onChecked={handleCheckCheckbox}>
                    {label}
                </Checkbox>
            </Option>
        );
    });
    return <Wrapper>{_options}</Wrapper>;
};

const init = (options) => {
    let selectedState = {};
    options.forEach(({ _, value }) => {
        selectedState = { ...selectedState, [value]: false };
    });
    return selectedState;
};

const Wrapper = styled.div`
    width: 100%;
    box-sizing: border-box;
    background-color: ${white};
    padding: 16px;

    ${Label} {
        font: 15px/24px ${FontFamily.SharpSansSemibold};
    }
`;
const Option = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 16px;
    :last-child {
        margin-bottom: 0px;
    }
`;

export default CheckBoxGroup;
